export default class LoadingPromise {
  constructor () {
    this._promises = {
      all: []
    }
    this._loading = {
      all: null
    }
    this._id = 0
  }

  add (promise, scopes = []) {
    // const promisesObjs = this._buildPromisesObject([promise])
    // const definedScopes = ['all', ...scopes]
    // this._appendPromise(promisesObjs, definedScopes)
    // this._updateLoading(definedScopes)
    // this._cleanup(promisesObjs, definedScopes)

    this.addMany([promise], scopes)
  }

  addMany (promises, scopes = []) {
    const promisesObjs = this._buildPromisesObject(promises)
    const definedScopes = ['all', ...scopes]
    this._appendPromise(promisesObjs, definedScopes)
    this._updateLoading(definedScopes)
    this._cleanup(promisesObjs, definedScopes)
  }

  isLoading (scope = 'all') {
    return this._loading[scope]
  }

  _buildPromisesObject (promises) {
    return promises.map(promise => ({ promise, id: this._id++ }))
  }

  _appendPromise (promisesObjs, scopes) {
    const promisesCopy = Object.assign({}, this._promises)
    scopes.forEach(scope => {
      const promisesScope = promisesCopy[scope] || []
      promisesCopy[scope] = promisesScope.concat(promisesObjs)
    })
    this._promises = promisesCopy
  }

  _updateLoading (scopes) {
    const loadingCopy = Object.assign({}, this._loading)
    scopes.forEach(scope => {
      const promisesScope = this._promises[scope] || []
      loadingCopy[scope] = Promise.all(promisesScope.map(p => p.promise))
    })
    this._loading = loadingCopy
  }

  _cleanup (promisesObjs, scopes) {
    promisesObjs.forEach(promiseObj => {
      const { promise, id } = promiseObj
      promise.then(
        _val => this._removePromise(scopes, id),
        _err => this._removePromise(scopes, id)
      )
    })
  }

  _removePromise (scopes, id) {
    const promisesCopy = Object.assign({}, this._promises)
    scopes.forEach(scope => {
      const promisesScope = promisesCopy[scope] || []
      promisesCopy[scope] = promisesScope.filter(p => p.id !== id)
    })
    this._promises = promisesCopy
  }
}
